import React from "react";
import { Link, useParams } from "react-router-dom";
import Layout, { Main } from "./Layout";
import { useApi } from "./Api/ApiContext";
import { useAsync } from "react-use";
import { Alert, Col, Row, Spinner } from "reactstrap";

const ConfirmEmailPage = () => {
  const { confirmEmailAddress } = useApi();
  const { token } = useParams();
  const { error, value, loading } = useAsync(() => confirmEmailAddress(token));

  if (loading) {
    return (
      <Layout>
        <Main>
          <Row>
            <Col lg={6} className={"mx-auto"}>
              <Spinner color={"danger"} />
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <Main>
          <Row>
            <Col lg={6} className={"mx-auto"}>
              <Alert color={"danger"}>
                Une erreur s'est produite. Merci de réessayer plus tard.
              </Alert>
            </Col>
          </Row>
        </Main>
      </Layout>
    );
  }
  return (
    <Layout backPath={{ pathname: "/" }}>
      <Main>
        <Row className={"mt-4"}>
          <Col lg={6} className={"mx-auto"}>
            <Alert>
              <h3>Félicitation!</h3>
              <div>Votre adresse e-mail a été confirmé.</div>
            </Alert>
          </Col>
        </Row>
        <Row className={"mt-4"}>
          <Col lg={6} className={"mx-auto"}>
            <h4>Prochaines étapes:</h4>
          </Col>
        </Row>
        <Row className={"mt-4"}>
          <Col lg={6} className={"mx-auto"}>
            <p>
              Nos équipes vérifieront et valideront votre profil. Un message de
              validation de votre profil vous sera envoyé. Vous pourriez dès
              lors :
            </p>
            <ol>
              <li>vous connecter à votre espace.</li>
              <li>Ajouter une photo de profil</li>
              <li>Ajouter vos produits et recevoir vos premières commandes.</li>
            </ol>
          </Col>
        </Row>
      </Main>
    </Layout>
  );
};

export default ConfirmEmailPage;
